import { ref } from "vue";
import { defineStore } from "pinia";
import type { Licence } from "@/types/licenceSolutions";
import { getLicencesForOrg, clearLicencesCache } from "@/utils/licenceApi";

export const useSolutionsStore = defineStore("solutions", () => {
  const solutions = ref<Licence[]>([]);

  const setSolutions = (data: Licence[]): void => {
    solutions.value = data;
  };

  const resetState = (): void => {
    setSolutions([]);
    clearLicencesCache();
  };

  const getSolutions = async ({ uuid }: { uuid: string }): Promise<void> => {
    if (!uuid) {
      throw new Error("Organisation ID is not provided");
    }

    const data = (await getLicencesForOrg(uuid)) as {
      licences?: Licence[];
      data?: { licences?: Licence[] };
    };

    setSolutions(data.licences ?? data?.data?.licences ?? []);
  };

  return { solutions, setSolutions, resetState, getSolutions };
});
